import React from 'react';
import '../../pages/selfcare/resumeSelfcare.css';
import { getSelfcareScoreTier, roundHalfUp } from '../../pages/selfcare/selfcareReportLogic';

/**
 * ScoreCardSelfcare
 *
 * Props:
 *  - value : Indice IASH global.
 *  - label : etiqueta del puntaje.
 */
const ScoreCardSelfcare = ({ value, label = 'Índice IASH' }) => {
    const mainScore = roundHalfUp(value, 2) ?? 0;
    const tier = getSelfcareScoreTier(mainScore);

    return (
        <div className="selfcare-score-card" style={{ backgroundColor: tier.color, color: tier.textColor }}>
            <div className="selfcare-score-main">
                <div className="selfcare-score-label">{label}</div>
                <div className="selfcare-score-value">{mainScore.toFixed(2)}</div>
            </div>
            <div className="selfcare-score-tier">{tier.label}</div>
        </div>
    );
};

export default ScoreCardSelfcare;
